/* tslint:disable:max-line-length */
import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {Size, TextAnnotation} from '@mydocma/component-library/src/lib/annotation';
import {PinStyleEnum} from '@docma-mm-core/scribble/pin-style.enum';
import {getOpacityFromARGB, toARGB, toRGB} from './converter';

export class TextConverter {

  /* COMPONENT MODEL TO SCRIBBLE */
  static convertToData(anno: TextAnnotation, containerSize: Size): ScribbleData {
    const adjustedMinX = anno.left;
    const adjustedMinY = anno.top;

    const stageWidth = containerSize.width;
    const stageHeight = containerSize.height;
    const relX = adjustedMinX / stageWidth;
    const relY = adjustedMinY / stageHeight;
    const relW = anno.width / stageWidth;
    const relH = anno.height / stageHeight;

    const data: ScribbleData = {
      UniqueId: anno.id,
      RelativeBasePointToParentPositionX: relX + (relW * 0.5),
      RelativeBasePointToParentPositionY: relY + (relH * 0.33),
      RelativeScaleX: relW,
      RelativeScaleY: relH,

      RelativeAnchorToParentPositionX: 0,
      RelativeAnchorToParentPositionY: 0,

      RelativeAnchorToCanvasPositionX: 0.5,
      RelativeAnchorToCanvasPositionY: 0.5,
      RelativeTextBoxToCanvasOffsetX: 0.5,
      RelativeTextBoxToCanvasOffsetY: 0.33,
      TextBoxAlignmentValue: 32,

      PinShape: anno.type,
      PinStyle: PinStyleEnum.Form,

      TextBoxFontColorValue: toARGB(anno.style.text.color),
      TextBoxBackgroundColorValue: anno.style.fillColor && anno.style.fillColor !== 'transparent' ? toARGB(anno.style.fillColor) : '#00FFFFFF',
      TextBoxFontSize: anno.style.text.size,
      FillColorValue: anno.style.fillColor && anno.style.fillColor !== 'transparent' ? toARGB(anno.style.fillColor) : '#00FFFFFF',
      Text: anno.text,
    };
    return data;
  }

  /* SCRIBBLE TO COMPONENT MODEL */
  static convertToModel(scribble: ScribbleData, container: Size): TextAnnotation {
    const width = (scribble.RelativeScaleX || 0) * container.width;
    const height =  (scribble.RelativeScaleY || 0) * container.height;
    const fillOpacity = (scribble.TextBoxBackgroundColorValue ? getOpacityFromARGB(scribble.TextBoxBackgroundColorValue) : 1);

    const anno = {
      type: scribble.PinShape,
      id: scribble.UniqueId,
      text: scribble.Text,
      width,
      height,
      left: container.width * scribble.RelativeBasePointToParentPositionX - (scribble.RelativeTextBoxToCanvasOffsetX || 0) * width,
      top: container.height * scribble.RelativeBasePointToParentPositionY - (scribble.RelativeTextBoxToCanvasOffsetY || 0) * height,
      style: {
        text: {
          size: scribble.TextBoxFontSize,
          color: toRGB(scribble.TextBoxFontColorValue),
        },
        fillColor: (!scribble.TextBoxBackgroundColorValue || fillOpacity === 0 ? null : toRGB(scribble.TextBoxBackgroundColorValue))
        // scribble.FillColorValue === '#FFFFFFFF' ? null :
        // ote: In Classic created texts cant have fill color but api returns  #FFFFFFFF for transparent - Must be ignored, in web white would be #fffff
      }
    } as TextAnnotation;

    return anno;
  }
}
